export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
    tag: '2',
    action: 'default',
  },
]
